<template>
<div id="app" v-loading.fullscreen.lock="!$teras.app.ready" :class="'device-'+$teras.app.device">
   
   <sidebar v-on:toggle="$teras.event.emit('sidebarToggle')" >
      <div slot="sidebar" class="yo-text-l yo-color-primary yo-align-center yo-valign-text-center" style="background:#fff;height:40px;">TESORERIA {{$socio.sigla}}</div>
   </sidebar>

   <div class="header-top yo-fixed-top" style="z-index:1001">
      <siteHeader></siteHeader>

   </div>

   <div class="app-main row">
      <div id="main" class="col s12" >
         <router-view name="main"></router-view>
      </div><!-- end main -->
   </div><!-- end container -->
   
   
   
   <div class="app-footer yo-fixed-bottom yo-text-n ">
      <siteFooter v-if="!(['savethedate'].indexOf($route.name) > -1)"></siteFooter>
   </div>  
   
  <!--
    Il nostro sito web utilizza i cookie per assicurarti la miglior esperienza di navigazione. Se desideri maggiori informazioni sui cookie e su come controllarne l'abilitazione con le impostazioni del browser consulta la nostra Cookie Policy
  -->
  
</div> <!-- end app -->
</template>

<script>
import sidebar from './components/Sidebar'
import siteHeader from './components/Site-header.vue'
import siteFooter from './components/Site-footer.vue'
export default {
   name: 'app',
   components: {
      sidebar,
      siteHeader,
      siteFooter
   }
}
</script>
